import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	description: {
		id: 'eoc.heartbeats.empty-state.description.no-translate',
		defaultMessage:
			'Create a heartbeat to monitor the connectivity of your systems by using the <linkRestApi>Heartbeats API</linkRestApi> or sending an email. <linkReadMore>Read more about heartbeats</linkReadMore>',
		description: 'Description of the empty state',
	},
	cancel: {
		id: 'eoc.heartbeats.cancel.no-translate',
		defaultMessage: 'Cancel',
		description: 'Cancel button text.',
	},
	chevronDownIconLabel: {
		id: 'eoc.heartbeats.chevron-down-icon-label.no-translate',
		defaultMessage: 'Chevron down',
		description: 'Chevron down icon label.',
	},
	closeFocusState: {
		id: 'eoc.heartbeats.close-focus-state-icon-label.no-translate',
		defaultMessage: 'Close focus state',
		description: 'Chevron down icon label.',
	},
	errorTitle: {
		id: 'eoc-heartbeats.error-title.no-translate',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
});

export default messages;
